// extracted by mini-css-extract-plugin
export default {"price":"U8-z","onSale":"V8-z","msrpLabelPrice":"W8-z","msrpLabel":"X8-z","originalPrice":"Y8-z","percentOff":"Z8-z"};